import { GridItem } from "./grid-item";

export class GridMatrix {
	data:(GridItem | undefined)[][] = [];

	public constructor(){

	}

	public setRect(minX:number, minY:number, width:number, height:number, data:GridItem | undefined){
		for (let y = minY; y< (minY+height); y++){
			let row = this.data[y] || [];
			if (!this.data[y]){
				this.data[y] = row;
			}
			for (let x = minX; x<(minX+width); x++){
				row[x] = data;
			}
		}
	}

	public isRectEmpty(minX:number, minY:number, width:number, height:number):boolean {
		for (let y = minY; y< (minY+height); y++){
			let row = this.data[y] || [];
			for (let x = minX; x<(minX+width); x++){
				if (row[x]){
					return false;
				}
			}
		}
		return true;
	}

	public removeEmptyRows(){
		for (let row = this.data.length -1; row >= 0; row--){
			if (!this.data[row]) {
				this.data.splice(row, 1);
				continue;
			}
			if (this.data[row].length == 0){
				this.data.splice(row,1);
			}
		}
		this.fixPositions();
	}

	public fixPositions(){
		let startPositionsSet:GridItem[] = [];
		for (let row = 0; row < this.data.length; row++){
			for (let col = 0; col < this.data[row].length; col++){
				let item = this.data[row][col];
				if (!item) continue;
				if (startPositionsSet.indexOf(item) == -1){
					item.col = col;
					item.row = row;
					startPositionsSet.push(item);
				}
			}
		}
	}
}